import React, {useContext} from 'react';
import './MinicartTrigger.less';
import {CartCaption} from 'elements/cart-caption/CartCaption';
import {MinicartTotal} from 'elements/minicart-total/MinicartTotal';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {MinicartTriggerChevron} from "elements/minicart-trigger-chevron/MinicartTriggerChevron";

export const MinicartTrigger = ({total, onClick}) => {
	const translations = useContext(TranslationsContext);

	return (
		<a className="minicart-trigger" onClick={onClick}>
      <span className="minicart-trigger__caption">
        <CartCaption text={getSafeTranslation('MinicartTrigger.cartCaption', translations)}/>
      </span>
			<span className="minicart-trigger__icon">
        <MinicartTriggerChevron/>
      </span>
			<span className="minicart-trigger__total">
        <MinicartTotal price={total}/>
      </span>
		</a>
	);
};
